<template>
  <v-dialog
    :max-width="width"
    :model-value="true"
    :persistent="persistent"
    eager
    opacity="0.55"
    scrim="#191717"
    @update:model-value="change"
    @keydown.esc="choose(undefined)"
  >
    <v-card
      class="confirm-dialog"
      rounded="xl"
    >
      <div class="confirm-dialog__header">
        <v-avatar
          v-if="!!icon"
          :color="destructive ? 'error' : color"
          size="40"
          variant="tonal"
        >
          <v-icon
            :icon="icon"
            size="22"
          />
        </v-avatar>
        <h2
          v-if="!!title"
          class="confirm-dialog__title"
        >
          {{ title }}
        </h2>
        <v-btn
          v-if="showCancel"
          aria-label="Close"
          class="confirm-dialog__close"
          color="secondary"
          density="comfortable"
          icon="mdi-close"
          size="small"
          variant="text"
          @click="choose(undefined)"
        />
      </div>
      <div class="confirm-dialog__body">
        <slot name="message">
          {{ message }}
        </slot>
      </div>
      <div class="confirm-dialog__actions">
        <v-btn-secondary
          v-if="Boolean(buttonFalseText)"
          :text="buttonFalseText"
          @click="choose(false)"
        />
        <v-btn-primary
          v-if="Boolean(buttonTrueText)"
          :color="destructive ? 'error' : buttonTrueColor"
          :text="buttonTrueText"
          @click="choose(true)"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">

export default {
  props: {
    buttonTrueText: {
      type: String,
      default: 'Confirm'
    },
    buttonFalseText: {
      type: String,
      default: 'Cancel'
    },
    buttonTrueColor: {
      type: String,
      default: 'primary'
    },
    color: {
      type: String,
      default: 'warning'
    },
    icon: {
      type: String,
      default: 'mdi-alert'
    },
    message: {
      type: String,
      required: true
    },
    persistent: Boolean,
    title: {
      type: String,
      default: undefined
    },
    width: {
      type: Number,
      default: 450
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  computed: {
    destructive(): boolean {
      return ['red', 'error'].includes(this.color)
    }
  },
  mounted() {
    document.addEventListener('keyup', this.onEnterPressed)
  },
  unmounted() {
    document.removeEventListener('keyup', this.onEnterPressed)
  },
  methods: {
    onEnterPressed(e) {
      if (e.keyCode === 13) {
        e.stopPropagation()
        this.choose(true)
      }
    },
    choose(value) {
      this.$emit('close', value)
    },
    change() {
      this.$emit('close', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  &__header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px 20px 0 32px;
  }

  &__title {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0;
    color: rgb(var(--v-theme-on-surface));
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.75rem;
    letter-spacing: -0.01em;
  }

  &__close {
    flex: 0 0 auto;
    margin-left: auto;
  }

  &__body {
    padding: 16px 32px 24px;
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
    font-size: 0.9375rem;
    line-height: 1.5rem;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 32px 24px;
    border-top: thin solid rgba(var(--v-border-color), var(--v-border-opacity));

    .v-btn {
      min-width: 120px;
    }
  }
}
</style>
